import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import * as API from '@/api';

// ==================== STATE =====================
function initialState() {
  return {
    filter: {
      rights: null,
      countries: null,
      genres: null,
      types: null,
      formats: null,
      title: null,
      exclusive: null,
      release_year: null,
    },
    selected: {
      rights: null,
      countries: null,
      genres: null,
      types: null,
      formats: null,
      title: null,
      exclusive: null,
      release_year: null,
    },
  };
}

const state = initialState();

// ==================== ACTIONS =====================

const actions = {
  async listFilms(context, payload) {
    var response = await API.filter.listFilms(payload);
    context.commit(
      'film/set_list',
      {
        films: response.result,
      },
      DEFINES.USE_ROOT,
    );
    return response;
  },
};

// ==================== GETTERS =====================
const getters = {
  getField,

  is_applied: state => {
    // Check if any filter having null, empty value and if type array then having zero length.
    let is_empty = Object.values(state.filter).every(
      x => x === null || x === '' || (Array.isArray(x) && x.length <= 0),
    );
    return is_empty ? false : true;
  },

  getApplied: state => {
    return state.filter;
  },

  isRightsOrCountriesApplied: state => {
    var data = [state.filter.rights, state.filter.countries];
    let is_empty = Object.values(data).every(
      x => x === null || x === '' || x.length <= 0,
    );
    return is_empty ? false : true;
  },
};

// ==================== MUTATIONS =====================
const mutations = {
  updateField,
  set_filters_from_link(state, payload) {
    var filters = JSON.parse(payload.filters);
    Object.assign(state.filter, filters);
    Object.assign(state.selected, filters);
  },

  set_filters(state) {
    Object.assign(state.filter, state.selected);
  },

  removeApplied: (state, payload) => {
    // Payload would have and id if filter is of type array otherwise we can set null directly to key
    if (payload.id) {
      for (var i = 0; i < state.filter[payload.label].length; i++) {
        if (state.filter[payload.label][i] === payload.id) {
          state.filter[payload.label].splice(i, 1);
        }
      }
      for (var j = 0; j < state.selected[payload.label].length; j++) {
        if (state.selected[payload.label][j] === payload.id) {
          state.selected[payload.label].splice(j, 1);
        }
      }
    } else {
      state.filter[payload.label] = null;
      state.selected[payload.label] = null;
    }
  },

  resetAllFilters(state) {
    Object.keys(state.filter).forEach(key => {
      state.filter[key] = null;
    });
    Object.keys(state.selected).forEach(key => {
      state.selected[key] = null;
    });
  },

  resetOnlyAvailabilityFilters(state) {
    state.filter.rights = state.selected.rights = null;
    state.filter.countries = state.selected.countries = null;
    state.filter.exclusive = state.selected.exclusive = null;
  },

  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
